export default "__VITE_ASSET__bca675b5__"